export default __webpack_public_path__ + "static/media/f_f_health_50_s512_f_health_50_2bg.7865758d.png";